import {
  Bold,
  CodeBlock,
  CodeInline,
  Color,
  ColorHighlighter,
  Emoji,
  HandleBackSpace,
  Italic,
  Link,
  Mention,
  Strikethrough,
  TypographyInputRules,
  Underline,
} from '@lyearn/lygo-blocks';

export const quizEditorExtensions = [
  Emoji,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Link,
  Color,
  Mention,
  CodeInline,
  TypographyInputRules,
  ColorHighlighter,
  CodeBlock,
  HandleBackSpace,
];
